var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TrialHeaderBox"},[_c('div',{staticClass:"the_trial_head"},[_c('div',{staticClass:"tips"},[_vm._v("还款试算")]),_c('div',{staticClass:"the_base"},[_c('div',{staticClass:"angle"}),_c('p',{staticClass:"tip_money"},[_vm._v("贷款金额")])])])])
}]

export { render, staticRenderFns }